import { createConsumer } from "@rails/actioncable"

let consumerInstance = null;
let visibilityHandlerBound = false;

const bindVisibilityReconnect = (consumer) => {
  if (visibilityHandlerBound) return;
  visibilityHandlerBound = true;

  let connectionAttempts = 0;
  const maxConnectionAttempts = 5;

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && !consumer.connection.isActive() && connectionAttempts < maxConnectionAttempts) {
      connectionAttempts++;
      consumer.connection.open();
    }
  });

  consumer.connection.onopen = () => {
    connectionAttempts = 0;
  };
};

export const getConsumer = () => {
  if (!consumerInstance) {
    consumerInstance = createConsumer('/cable');
    bindVisibilityReconnect(consumerInstance);
  }
  return consumerInstance;
};

export default {
  get subscriptions() {
    return getConsumer().subscriptions;
  },
  get connection() {
    return getConsumer().connection;
  }
};
